import { useEffect } from "react"

const OverlapVideo = ({videoFound, videoUrls}) => {
    const handleVideoError = () =>{
        
    }

    return (
        <>
            <div className="filmroom_video_frame" style={{"position": "relative"}}>
            {videoFound ? (
                <>
                    <video
                        width="100%"
                        height="100%"
                        src={videoUrls[0]}
                        title="YouTube video player"
                        preload="auto"
                        controls
                        autoPlay
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        onError={handleVideoError}
                    ></video>
                    <video
                        width="100%"
                        height="100%"
                        src={videoUrls[1]}
                        title="YouTube video player"
                        preload="auto"
                        controls
                        autoPlay
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        onError={handleVideoError}
                        style={{"position": "absolute", "opacity": 0.9}}
                    ></video>
                </>
            ) : (
                <span>未選擇影片/影片播放錯誤/影片不存在</span>
            )}
            </div>
        </>
    )
}

export default OverlapVideo